export const siteName = 'Pedale - Aluguel de Bicicletas'

export const config = {
   env: "production",
   transferTransactionCost: 4.9,
   ownerFeePedale: 8,
   ownerSplit: 23,
   cyclistFeePedale: 15,
   cyclistFeeJuno: 2.99,
   cyclistFixedFeeJuno: 0.4,
   pf: {
      rates: {
         serviceCostPercentage: 23
      },
      numberOfBikes: 5
   },
   pj: {
      rates: {
         serviceCostPercentage: 17
      },
      numberOfBikes: 50
   },
}
